import React from 'react';
import { Outlet } from 'react-router-dom';
import undraw from '../assets/admin.svg'


const AuthPage = () => {
    return (
       <div className='h-screen flex justify-center items-center w-full'>
         <div className='flex justify-center items-center rounded-lg max-w-[1240px]'>
            <div className='w-1/2 hidden sm:block rounded-l-lg p-10 border-r'>
                <img
                src={undraw}
                className=' mx-auto '
                />
            </div>
            <div className='sm:w-1/2 sm:mt-10 '>
                <Outlet/>
            </div>
            
        </div>
       </div>
    );
}

export default AuthPage;
